import { apiClient } from '../../plugins/api'
import {
    CHECK_NAME_REQUEST,
    CREATE_REQUEST,
    CREATE_SUCCESS,
    DISBAND_TEAM_REQUEST,
    DISBAND_TEAM_SUCCESS,
    LEAVE_TEAM_REQUEST,
    LEAVE_TEAM_SUCCESS,
    MY_TEAM_REQUEST,
    MY_TEAM_SUCCESS,
    SUGGEST_REQUEST,
    LISTING_TEAMS_REQUEST,
    FORGOT_TEAM,
    JOIN_TEAM_REQUEST,
    ACCEPT_JOIN_REQUEST,
    DECLINE_JOIN_REQUEST,
    LOAD_TEAM_REQUESTS_REQUEST,
    GET_TEAM_DETAIL_REQUEST,
    RELOAD_MY_TEAM_MEMBERS_REQUEST,
    RELOAD_MY_TEAM_MEMBERS_SUCCESS,
    FIRE_TEAM_MEMBER_REQUEST,
    USER_INVITE_REQUEST,
    ACCEPT_INVITATION_REQUEST,
    DECLINE_INVITATION_REQUEST,
    GET_MY_TEAM_REQUESTS_REQUEST, UPDATE_TEAM_REQUEST, UPDATE_TEAM_SUCCESS,
} from '../actions/team'

import { SET_USER_TEAM } from '../actions/user'
import { GAME_STATUS_REQUEST } from '../actions/game';

const state = {
    myTeam: null,
    myTeamRequests: [],
    loadingMyTeam: false,
};

const getters = {
    myTeamLoaded: state => state.myTeam !== null,
    canAddMember: state => {
        return state.myTeam
            && state.myTeam.permissions.canAddMember
            && state.myTeam.players.length < 5;
    },
};

const actions = {
    async [SUGGEST_REQUEST] ({ commit }, { term }) {
        const { data } = await apiClient().get('/team/suggest?name=' + term);
        return data.teams;
    },
    async [CHECK_NAME_REQUEST] ({ commit }, { name }) {
        const { data } = await apiClient().get('/team/check-name?name=' + name);
        return data.isAvailable;
    },
    async [CREATE_REQUEST] ({ commit }, { name }) {
        const { data } = await apiClient().post('/team/create', { name });
        commit(CREATE_SUCCESS, data);
        commit('user/' + SET_USER_TEAM, { teamId: data.team.id, teamName: data.team.name }, { root: true });
    },
    async [MY_TEAM_REQUEST] ({ commit }) {
        try {
            const { data } = await apiClient().get('/team/my-team');
            commit(MY_TEAM_SUCCESS, data);
            commit('user/' + SET_USER_TEAM, {
                teamId: data.team.id,
                teamName: data.team.name,
                teamBlazon: data.team.blazon,
            }, { root: true });
        } catch (e) {
            if (e.response.status === 404) {
                return;
            }

            throw e;
        }
    },
    async [DISBAND_TEAM_REQUEST] ({ commit }) {
        await apiClient().post('/team/disband');
        commit(DISBAND_TEAM_SUCCESS);
        commit('user/' + SET_USER_TEAM, { teamId: null }, { root: true });
    },
    async [LEAVE_TEAM_REQUEST] ({ commit }) {
        await apiClient().post('/team/leave');
        commit(LEAVE_TEAM_SUCCESS);
        commit('user/' + SET_USER_TEAM, { teamId: null }, { root: true });
    },
    async [LISTING_TEAMS_REQUEST] () {
        const { data } = await apiClient().get('/team/find');
        return data.teams;
    },
    async [JOIN_TEAM_REQUEST] ({ commit }, { teamId }) {
        return await apiClient().post('/team/team-request', { teamId });
    },
    async [ACCEPT_JOIN_REQUEST] ({ commit, dispatch }, { requestId }) {
        await apiClient().post('/team/accept-join', { requestId });
        dispatch(RELOAD_MY_TEAM_MEMBERS_REQUEST);
    },
    async [DECLINE_JOIN_REQUEST] ({ commit }, { requestId }) {
        await apiClient().post('/team/decline-join', { requestId });
    },
    async [ACCEPT_INVITATION_REQUEST] ({ commit, dispatch }, { requestId, teamId, teamName }) {
        await apiClient().post('/team/accept-invitation', { requestId });
        commit('user/' + SET_USER_TEAM, { teamId, teamName }, { root: true });
        dispatch(MY_TEAM_REQUEST);
        dispatch('game/' + GAME_STATUS_REQUEST, {}, { root: true });
    },
    async [DECLINE_INVITATION_REQUEST] ({ commit }, { requestId }) {
        await apiClient().post('/team/decline-invitation', { requestId });
    },
    async [LOAD_TEAM_REQUESTS_REQUEST] () {
        const { data } = await apiClient().get('/team/join-requests');
        return data.requests;
    },
    async [GET_TEAM_DETAIL_REQUEST] ({ commit }, { id }) {
        const { data } = await apiClient().get('/team/detail?id=' + id);
        return data.team;
    },
    async [RELOAD_MY_TEAM_MEMBERS_REQUEST] ({ commit, getters }) {
        if (!getters['myTeamLoaded']) {
            return;
        }

        const { data } = await apiClient().get('/team/my-team');
        commit(RELOAD_MY_TEAM_MEMBERS_SUCCESS, data.team.players);
    },
    async [FIRE_TEAM_MEMBER_REQUEST] ({ dispatch }, { memberId }) {
        await apiClient().post('/team/fire-member', { memberId });
        dispatch(RELOAD_MY_TEAM_MEMBERS_REQUEST);
    },
    async [USER_INVITE_REQUEST] ({ commit }, { userId }) {
        await apiClient().post('/team/invite-user', { userId });
    },
    async [GET_MY_TEAM_REQUESTS_REQUEST] () {
        const { data } = await apiClient().get('/team/my-requests');
        return data.requests;
    },
    async [UPDATE_TEAM_REQUEST] ({ commit }, { blazon }) {
        await apiClient().post('/team/update-team', { blazon });
        commit(UPDATE_TEAM_SUCCESS, { blazon });
    },
};

const mutations = {
    [CREATE_SUCCESS] (state, { team }) {
        state.myTeam = team;
    },
    [MY_TEAM_SUCCESS] (state, { team }) {
        state.myTeam = team;
    },
    [DISBAND_TEAM_SUCCESS] (state) {
        state.myTeam = null;
    },
    [LEAVE_TEAM_SUCCESS] (state) {
        state.myTeam = null;
    },
    [FORGOT_TEAM] (state) {
        state.myTeam = null;
    },
    [RELOAD_MY_TEAM_MEMBERS_SUCCESS] (state, members) {
        state.myTeam.players = members;
    },
    [UPDATE_TEAM_SUCCESS] (state, { blazon }) {
        state.myTeam.blazon = blazon;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
